import type { BadgeTone } from '@eombor/ui';
import type { SurveyStatus } from '@eombor/contracts';

/**
 * Buxgalteriya ekranlarining ko'rinish yordamchilari.
 *
 * Miqdor `numeric(14,3)` bilan BIR XIL yumaloqlanadi: hujjatdagi raqam bilan
 * ekrandagi raqam farq qilsa, hisobchi qaysi biriga ishonishni bilmaydi.
 */
export const qtyText = (qty: number): string => String(Math.round(qty * 1000) / 1000);

/** Sana: "12.08.2026". Vaqt ko'rsatilmaydi — hujjat kun aniqligida yashaydi. */
export const formatDate = (iso: string | null): string | null => {
  if (iso === null) return null;
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return iso;
  const pad = (value: number): string => String(value).padStart(2, '0');
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;
};

/**
 * So'rovnoma holatining RANGI.
 *
 * Ko'k — kimningdir navbatida turibdi; yashil urg'u — tasdiqlangan va undan
 * prixod tug'ilgan; qizil — to'xtadi. Talabnoma holatlari bilan bir xil mantiq
 * (`requisition-status.ts`), shuning uchun ikki ekran bir tilda gapiradi.
 */
const SURVEY_TONES: Record<SurveyStatus, BadgeTone> = {
  PENDING: 'info',
  APPROVED: 'accent',
  REJECTED: 'danger',
};

export const surveyStatusTone = (status: SurveyStatus): BadgeTone => SURVEY_TONES[status];

/**
 * So'ralgan va tasdiqlangan miqdor FARQI.
 *
 * `null` — tasdiqlangan miqdor hali yo'q (solishtirishga narsa yo'q) yoki
 * farq nolga teng. Nolni ham "farq" deb ko'rsatish jadvalni ogohlantirish
 * belgilariga to'ldirib yuborardi va haqiqiy farq ko'zga tashlanmasdi.
 */
export const qtyDiff = (requestedQty: number, approvedQty: number | null): number | null => {
  if (approvedQty === null) return null;
  const diff = Math.round((approvedQty - requestedQty) * 1000) / 1000;
  return diff === 0 ? null : diff;
};

/** Farqni ishorasi bilan: "-20", "+5". */
export const diffText = (diff: number): string =>
  `${diff > 0 ? '+' : ''}${qtyText(diff)}`;
